//namespace
window.QJTApp = window.QJTApp || { modules: {} };

QJTApp.modules.home             = QJTApp.modules.home || {};
QJTApp.modules.home.models      = QJTApp.modules.home.models || {};
QJTApp.modules.home.views       = QJTApp.modules.home.views || {};
QJTApp.modules.home.collections = QJTApp.modules.home.collections || {};
QJTApp.modules.home.routes      = QJTApp.modules.home.routes || {};

QJTApp.modules.home.views.AllItemsView = Backbone.Marionette.CollectionView.extend({

  tagName: 'section',

  id: 'items-container',

  childView: QJTApp.modules.home.views.ItemView,

  initialize: function() {
    //console.log('AllItemsView init...');
  },

  onRender: function(){
    // do stuff here
    //console.log('AllItemsView rendered!');
  }

});